import { HTMLAttributes } from "react"
import { styled, StyleProps } from "../../styles"

const StyledTag = styled.span<HTMLAttributes<HTMLSpanElement>>((props: StyleProps) => ({
  display: `inline-block`,
  padding: props.theme.spacing(4, 6),
  marginTop: props.theme.spacing(4),
  backgroundColor: props.theme.palette.grey.light,
  borderRadius: props.theme.borderRadius.sm,
  border: `1px solid ${props.theme.palette.grey.dark}`,

  "&:not(:last-child)": {
    marginRight: props.theme.spacing(4),
  },
}))

export default StyledTag
